import {
  Component,
  ChangeDetectionStrategy,
  Output,
  Input,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-iframe',
  templateUrl: 'iframe.component.html',
  styleUrls: ['iframe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeComponent {
  @Input() url: string;
  @Output() iframeLoad = new EventEmitter();

  constructor() {}
}
